import type { DataAccessRequestVerificationDetail } from 'services/data-access-requests/types'
import { isExternalImportRequestDetail } from 'services/import-requests/importRequestUtils'
import type { ImportRequestVerificationDetail } from 'services/import-requests/types'
import type { Result } from 'services/results/types'

import { RequestActivityRequestType } from './enums'
import type { RequestActivitySource } from './types'

export const toExportRequestActivitySource = (result: Result): RequestActivitySource => ({
  requestType: RequestActivityRequestType.Export,
  requestId: result._id,
  rejectionReason: result.rejectionReason
})

export const toDataAccessRequestActivitySource = (
  request: DataAccessRequestVerificationDetail
): RequestActivitySource => ({
  requestType: RequestActivityRequestType.DataAccess,
  requestId: request._id,
  rejectionReason: request.rejectionReason
})

export const toImportRequestActivitySource = (request: ImportRequestVerificationDetail): RequestActivitySource => ({
  requestType: RequestActivityRequestType.Import,
  requestId: request._id,
  rejectionReason: request.rejectionReason,
  importSource: request.source,
  importCounts: isExternalImportRequestDetail(request) ? request.counts : undefined
})
